import(/* webpackMode: "eager", webpackExports: ["toast","isActive","error"] */ "/codebuild/output/src2126065393/src/stage-webapp/node_modules/react-toastify/dist/react-toastify.esm.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["ClientInitializer"] */ "/codebuild/output/src2126065393/src/stage-webapp/src/components/ClientInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DatadogInit"] */ "/codebuild/output/src2126065393/src/stage-webapp/src/components/DatadogInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2126065393/src/stage-webapp/src/components/InitPolyfills.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2126065393/src/stage-webapp/src/components/NavigationLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StringsProvider"] */ "/codebuild/output/src2126065393/src/stage-webapp/src/context/StringsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/codebuild/output/src2126065393/src/stage-webapp/src/context/UserProvider.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2126065393/src/stage-webapp/src/utils/firebaseConfig.ts");
